import { Link } from "react-router-dom";

export interface Crumb {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mx-auto w-full max-w-7xl px-4 md:px-6 py-4">
      <ol className="flex flex-wrap items-center gap-1.5 font-label text-xs text-foreground-500">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-primary-600 transition-colors">
            <i className="ri-home-4-line"></i> 首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.name} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line"></i>
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors">{item.name}</Link>
            ) : (
              <span className="text-foreground-800" aria-current="page">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}